import { useEffect, useMemo } from 'react';
import useInterview from 'src/interviews/hooks/useInterview';
import useRelatedReading from '../../hooks/useRelatedReading';
import { Wrapper } from '../RichEndings';
import useRichEndingContext from '../RichEndings/useRichEndingContext';
import RelatedReading from './RelatedReading';

import type { RichEndingsProps } from '../RichEndings';

const RelatedReadingWrapper = (props: RichEndingsProps) => {
  const { interviewType } = props;

  const { token: interviewToken } = useInterview();
  const { setRelatedReadings } = useRichEndingContext();

  const { data, isLoading: readingDataLoading } = useRelatedReading(props);

  const relatedReadings = useMemo(() => data.related_readings, [data.related_readings?.length]);

  useEffect(() => {
    if (relatedReadings?.length) {
      setRelatedReadings(relatedReadings);
    }
  }, [relatedReadings, setRelatedReadings]);

  return !!relatedReadings?.length || readingDataLoading ? (
    <Wrapper component="RelatedReading">
      <RelatedReading
        readings={relatedReadings}
        interviewToken={interviewToken || ''}
        interviewType={interviewType}
        isLoading={readingDataLoading}
      />
    </Wrapper>
  ) : null;
};

export default RelatedReadingWrapper;
